import React, {useContext, useEffect, useState} from "react";
import {userServices} from "../../../../../services";
import Error from "../../../../error";
import {AppContext} from "../../../../../contexts/app-context";
import {Pagination} from "antd";
import Spinner from "../../../../spinner";
import {deliveriesConfig} from "../../../../../config";
import { unloadingsService } from "../../../../../services/unloadings.services";
import UnloadingItemBlock from "../../../../unloading-item-block";


export default function BuyerArchivedUnloadings()
{
  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(userServices.getUser());
  const [offset, setOffset] = useState(0);
  const [step, setStep] = useState(deliveriesConfig.pageCount);
  const [currentPage, setCurrentPage] = useState(1);
  const [errorMsg, setErrorMsg] = useState(null);
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  if (user.isGuest()) {
    return <Error status={403} desc="Страница не доступна"/>;
  }

  const getData = () => {
    unloadingsService.getArchived({limit: step, offset: offset, search: appContext.filter.searchString})
      .then((res) => {
        setItems(res.data.Unloadings);
        setTotalCount(res.data.TotalCount);
        appContext.setIsNeedUpdateUnloadingList(false);
        appContext.enableSearchFilter();
        setLoading(false);
      })
      .catch((errorMsg) => {
        setErrorMsg(errorMsg);
      });
  }

  useEffect(() => {
    if (loading === false || appContext.isNeedUpdateUnloadingList === true) {
      setLoading(true);
      getData();
    }
  }, []);


  useEffect(() => {
    if (loading === false || appContext.isNeedUpdateUnloadingList === true) {
      setLoading(true);
      getData();
    }
  }, [appContext.isNeedUpdateUnloadingList]);

  useEffect(() => {
    getData();
  }, [currentPage]);

  let onChange = (page, pageSize) => {
    if (page === currentPage) {
      return false;
    } else {
      setCurrentPage(page);
    }

    let val = 0;
    if (parseInt(page) === 1) {
      setOffset(0);
    } else {
      val = page * pageSize - pageSize;
      setOffset(val);
    }
  };

  return (
    <Spinner loading={loading}>
      {totalCount !== 0 ?
        <div className="application-block pagination pagination__up">
          <Pagination
            style={{textAlign: "center"}}
            current={currentPage}
            pageSize={step}
            total={totalCount}
            showTotal={(total, range) => `${range[0]}-${range[1]} из ${totalCount}`}
            onChange={onChange}
          />
        </div>
        : null
      }
      {items && items.length > 0 ?
        items.map((item, index) => <UnloadingItemBlock unloading={item} key={index}/>)
        : 
          <div className={`empty-delivery`}>
            <span className="empty-delivery__title">{"Разгрузки отсутствуют"}</span>
          </div>
      }
      {totalCount !== 0 ?
        <div className="application-block pagination pagination__down">
          <Pagination
            style={{textAlign: "center"}}
            current={currentPage}
            pageSize={step}
            total={totalCount}
            showTotal={(total, range) => `${range[0]}-${range[1]} из ${totalCount}`}
            onChange={onChange}
          />
        </div>
        : null}
    </Spinner>
  );
}